exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.who-to-follow *{vertical-align:middle\n}\n.who-to-follow img{width:32px;height:32px\n}\n.who-to-follow{padding:0em 1em;margin:0px\n}\n.who-to-follow-items{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding:0px;margin:1em 0em\n}\n.who-to-follow-more{padding:0px;margin:1em 0em;text-align:center\n}", ""]);

// exports
